module.exports = __webpack_public_path__ + "static/media/electrician.94ca970e.jpeg";